import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { from, take } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RedirectUrlService {
  constructor(private router: Router) {}
  private _redirectUrl: string | null = null;

  saveRedirectUrl(url: string) {
    this.redirectUrl = url;
  }

  navigateToRedirectUrl() {
    if (!!this.redirectUrl) {
      from(this.router.navigate([this.redirectUrl]))
        .pipe(take(1))
        .subscribe(() => {
          this.removeRedirectUrl();
        });
    }
  }

  existsRedirectUrl() {
    return !!this._redirectUrl;
  }

  getRedirectUrl() {
    return this._redirectUrl;
  }

  private removeRedirectUrl() {
    this._redirectUrl = null;
  }

  private set redirectUrl(url: string | null) {
    this._redirectUrl = url;
  }
  private get redirectUrl() {
    return this._redirectUrl;
  }
}
